import React from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom'
import { Avatar, Dropdown, MenuProps } from 'antd';
import styled from 'styled-components';
import logo from '../../images/logo.svg';
import bell from '../../images/bell.svg';
import iconProfile from '../../images/iconProfile.svg';
import useToken from '../../hooks/useToken';

const StyledNavbar = styled.div`
  a, .navbar-brand, .navbar-nav .nav-link {
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 22px;

      display: flex;
      align-items: center;

      text-decoration: none;
      color: #45505A;
      &:hover {
          color: #2196F3;
      }
      flex: none;
      margin-right:1.7%;
  }
`

export function AdminNavbar() {
  const { deleteToken } = useToken();

  const items: MenuProps['items'] = [
    {
      label: 'Выйти',
      key: '3',
      onClick: deleteToken
    }
  ];

  return (
    <StyledNavbar>
      <Navbar collapseOnSelect expand="md" bg="white" variant="white">
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Brand>
          <Link to="/"> 
            <img src={logo} height="74px" width="115px" className="logo" alt=''/> 
          </Link>
        </Navbar.Brand>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link><Link to="/registrationLinks"> Ссылки для регистрации </Link></Nav.Link>
            <Nav.Link><Link to="/vacancies"> Вакансии </Link> </Nav.Link>
            <Nav.Link><Link to="/contacts"> Контактные данные </Link></Nav.Link>
          </Nav>
        </Navbar.Collapse>
        <Nav className="me-auto" />
        <img src={bell} style={{marginRight: '17px', cursor:'pointer'}} alt=''/>
        <Dropdown menu={{ items }} trigger={['click']}>
            <Avatar src={iconProfile} style={{cursor:'pointer', height: '30px'}}/>
        </Dropdown>
      </Navbar>
    </StyledNavbar>
  )
}